<div
  class="wishlist-progress-summary"
  [class.wishlist-progress-summary-compact]="compact()"
>
  <div class="wishlist-progress-summary__label">{{ label() }}</div>
  <ui-progress-bar
    [value]="value()"
    [max]="max()"
    [ariaLabel]="label()"
    [tone]="tone()"
  />
  @if (hasSecondaryLabel()) {
    <small>{{ secondaryLabel() }}</small>
  }
</div>
